import { Map, Record } from "immutable";

import { syncStatusOptions } from "../../../constants/syncStatus";
import syncUpdateActions from "../../../constants/syncUpdateActions";
import createFromJS from "../../createFromJS";

export const SyncUpdateRecord = Record({
  id: null,
  action: syncUpdateActions.NONE,
  status: syncStatusOptions.DETECTED_NO_CHANGE,
  externalContentWillChange: false,
  parent: null,
  index: null,
  type: null,
  propertyUpdates: Map(),
  tagUpdates: Map(),
  relationshipUpdates: Map()
});

const data = {
  collections: {
    propertyUpdates: "SyncUpdatePropertyRecord",
    tagUpdates: "SyncUpdateTagRecord",
    relationshipUpdates: "SyncUpdateRelationshipRecord"
  }
};
createFromJS.registerCallback("SyncUpdateRecord", createFromJS.createNestedCallback(SyncUpdateRecord, data));
